import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";
import { Container, Row, Col } from "react-grid-system";

const ApiReference = () => (
  <>
    <Container className="landingGridContainer">
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs
            links={[
              { name: "Docs", url: "/docs" },
              { name: "API Reference", url: "/api-reference" },
            ]}
          />
          <h1>API Reference</h1>
          <p>Comprehensive reference documentation for Blues developer APIs</p>
        </Col>
      </Row>

      <hr />

      <Row>
        <Col>
          <div className="flex">
            <div>
              <h3>Notecard API</h3>
              <p>APIs for interacting with the Notecard in host firmware.</p>

              <div className="gridLinks">
                <h4>In this section</h4>
                <TrackedLink href="/api-reference/notecard-api/introduction">
                  Introduction
                </TrackedLink>
                <TrackedLink href="/api-reference/notecard-api/card-requests">
                  card Requests
                </TrackedLink>
                <TrackedLink href="/api-reference/notecard-api/dfu-requests">
                  dfu Requests
                </TrackedLink>
                <TrackedLink href="/api-reference/notecard-api/env-requests">
                  env Requests
                </TrackedLink>
                <TrackedLink href="/api-reference/notecard-api/file-requests">
                  file Requests
                </TrackedLink>
                <TrackedLink href="/api-reference/notecard-api/hub-requests">
                  hub Requests
                </TrackedLink>
                <TrackedLink href="/api-reference/notecard-api/note-requests">
                  note Requests
                </TrackedLink>
                <TrackedLink href="/api-reference/notecard-api/ntn-requests">
                  ntn Requests
                </TrackedLink>
                <TrackedLink href="/api-reference/notecard-api/var-requests">
                  var Requests
                </TrackedLink>
                <TrackedLink href="/api-reference/notecard-api/web-requests">
                  web Requests
                </TrackedLink>
              </div>
            </div>

            <div>
              <h3>Notehub API</h3>
              <p>APIs for interacting with Notehub over HTTP.</p>

              <div className="gridLinks">
                <h4>In this section</h4>

                <div>
                  <TrackedLink href="/api-reference/notehub-api/api-introduction">
                    Introduction
                  </TrackedLink>
                  <TrackedLink href="/api-reference/notehub-api/billing-account-api">
                    Billing Account API
                  </TrackedLink>
                  <TrackedLink href="/api-reference/notehub-api/device-api">
                    Device API
                  </TrackedLink>
                  <TrackedLink href="/api-reference/notehub-api/event-api">
                    Event API
                  </TrackedLink>
                  <TrackedLink href="/api-reference/notehub-api/monitor-api">
                    Monitor API
                  </TrackedLink>
                  <TrackedLink href="/api-reference/notehub-api/project-api">
                    Project API
                  </TrackedLink>
                  <TrackedLink href="/api-reference/notehub-api/route-api">
                    Route API
                  </TrackedLink>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <hr />
      <h2>Other Resources</h2>

      <Row>
        <Col>
          <div className="landing-page-link-list">
            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/notecard-guides.svg")}
              />
              <h4>Glossary</h4>
              <p>
                A comprehensive listing of terms and definitions used throughout
                Blues hardware and services.
              </p>
              <TrackedLink
                href="/api-reference/glossary"
                className="landingLink"
              >
                Read glossary
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/notehub-guides.svg")}
              />
              <h4>System Notefiles</h4>
              <p>
                A reference of all Notefiles created automatically on the
                Notecard and/or on Notehub.
              </p>
              <TrackedLink
                href="/api-reference/system-notefiles"
                className="landingLink"
              >
                Visit reference
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>

      <style jsx>{`
        .flex {
          display: flex;
          flex-wrap: wrap;
        }
        .flex div:first-child {
          margin-right: 3rem;
        }
        .flex p {
          max-width: 300px;
        }

        h3 {
          margin-top: 4rem;
        }

        .side-by-side {
          display: flex;
        }
      `}</style>
    </Container>
  </>
);

export default ApiReference;
